import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'glass';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  fullWidth?: boolean;
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  fullWidth,
  icon,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-gold/50 disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden group';
  const variants = {
    primary: 'bg-gold text-midnight hover:bg-gold-light shadow-[0_0_20px_rgba(212,175,110,0.3)] hover:shadow-[0_0_30px_rgba(212,175,110,0.5)]',
    secondary: 'bg-primary text-white border border-primary-light hover:bg-primary-light shadow-lg shadow-primary/20',
    outline: 'border border-gold/50 text-gold hover:bg-gold/10',
    ghost: 'text-beige hover:text-gold hover:bg-white/5',
    glass: 'glass text-white hover:border-gold/50 hover:text-gold'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const content = <>
      <span className="relative z-10 flex items-center" data-id="element-42">
        {children}
        {icon && <span className="ml-2" data-id="element-43">{icon}</span>}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-44"></div>}
    </>;
  if (href) {
    if (href.startsWith('http') || href.startsWith('mailto')) {
      return <a href={href} className={classes} target="_blank" rel="noopener noreferrer" data-id="element-45">
          {content}
        </a>;
    }
    return <Link to={href} className={classes} data-id="element-46">
        {content}
      </Link>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-47">
      {content}
    </motion.button>;
}